import { Yup } from '../../services/common/validation';

export const CarOptionsModalSchema = () => {
  return Yup.object().shape({
    optionPriceAmount: Yup.number(),
  });
};
